import { VStack } from "@chakra-ui/react";
import Nav from "../components/nav/Nav";

export default function VerifyEmail() {
  return (
    <VStack align={"stretch"} minH={"100vh"} gap={0}>
      <Nav />

      
    </VStack>
  );
}
